<template>
<div class="forum">
  <div class="bread">
    <router-link :to="{name:'Community'}">社区</router-link>
    <span class="slash">/</span>
    <span class="current">我的小组</span>
  </div>
  <div class="group-list">
    <div @click="$router.push({name: 'CommunityGroupShow',params:{id:item.id}})" class="item" v-for="(item,index) in myGroup">
      <div class="info">
        <div class="img">
          <img :src="item.image" />
        </div>
        <div class="content">
          <div class="name">
            <span>{{item.name}}</span>
          </div>
          <p class="number">
            <span>话题：{{item.post_num}}</span>
            <span class="user">成员：{{item.user_num}}</span>
          </p>
          <button @click.stop="outGroup(item.id)" type="button">退出小组</button>
        </div>
      </div>
      <div class="broadcast">
        <p class="title">版块介绍：</p>
        <p class="message">
          {{item.introduction}}
        </p>
      </div>
    </div>
    <Empty v-if="myGroup.length==0" class="empty" title="暂无小组！" />
    <el-pagination v-if="myGroup.length>0" background layout="prev, pager, next" @current-change="handle_current_change" :page-size="limit" :current-page="page" :total="totalPage">
    </el-pagination>
  </div>
</div>
</template>

<script>
export default {
  name: 'MineCommunity',
  data() {
    return {
      myGroup: [], //小组列表
      totalPage: 0, //话题数量
      page: 1, //话题分页
      limit: 6, //话题分页限制
    }
  },
  async created() {
    await this.getMineGroup()
  },
  mounted: function() {},
  methods: {
    // 获取我的小组
    async getMineGroup() {
      const that = this;
      let data = await that.$http.get('/api/app/community/group/myGroup',{
        limit: that.limit,
        page: that.page
      });
      that.myGroup = data.list;
      that.totalPage = data.total
    },

    // 取消加入
    async outGroup(id) {
      const that = this;
      if (that.$store.state.token) {
        let data = await that.$http.get('/api/app/community/group/outGroup/' + id);
        that.page = 1;
        that.getMineGroup();
        that.$message({
          type: 'success',
          message: '退出成功！'
        });
      } else {
        that.$router.push({
          name: 'Login'
        });
      }
    },

    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getMineGroup()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
    padding-bottom: 60px;
    overflow: hidden;
    .bread {
        width: 1200px;
        margin-right: auto;
        margin-left: auto;
        box-sizing: border-box;
    }
    .group-list {
        width: 1200px;
        margin: 0 auto 20px;
        .item {
            width: 100%;
            margin: 0 0 20px;
            padding: 24px;
            background: #fff;
            border-radius: 10px;
            box-sizing: border-box;
            cursor: pointer;
            .info {
                overflow: hidden;
                .img {
                    float: left;
                    width: 90px;
                    height: 90px;
                    overflow: hidden;
                    border-radius: 5px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .content {
                    margin-left: 110px;
                    width: auto;
                    .name {
                        font-size: 19px;
                        color: #20242A;
                        line-height: 26px;
                    }
                    .number {
                        margin-top: 10px;
                        font-size: 14px;
                        color: #8C8C8C;
                        line-height: 14px;
                        .user {
                            position: relative;
                            display: inline-block;
                            margin-left: 20px;
                            &::after {
                                content: '';
                                width: 1px;
                                height: 14px;
                                background-color: #fff;
                                position: absolute;
                                left: -10px;
                                top: 50%;
                                margin-top: -7px;
                            }
                        }
                    }
                    button {
                        margin-top: 15px;
                        width: 80px;
                        height: 23px;
                        line-height: 21px;
                        background: #F4F4F4;
                        border: none;
                        border-radius: 12px;
                        text-align: center;
                        font-size: 13px;
                        color: #8C8C8C;
                        cursor: pointer;
                        outline: none;
                        &:hover {
                          color: #000000
                        }
                    }
                }
            }
            .broadcast {
                margin-top: 30px;
                .title {
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    color: #20242A;
                }
                .message {
                    margin-top: 5px;
                    line-height: 22px;
                    overflow: hidden;
                    font-size: 14px;
                    color: #8C8C8C;
                }
            }
        }
    }
}
</style>
